import { ConvexReactClient } from "convex/react";
import { ConvexAuthProvider } from "@convex-dev/auth/react";

/*
 * رابط النشر يأتي من متغيّر البيئة وحده.
 * كان مكتوباً هنا صراحةً كقيمة احتياطية، وهذا الملف مرفوع على مستودع
 * عام، فكان الرابط متاحاً لأي أحد — ومعه البيانات، لأن دوال Convex
 * بلا مصادقة. لا تُعِد كتابة الرابط هنا.
 */
const convexUrl = process.env.REACT_APP_CONVEX_URL;

if (!convexUrl) {
  throw new Error(
    "REACT_APP_CONVEX_URL غير مضبوط — أضفه في ملف .env.local قبل التشغيل"
  );
}

// Create Convex client
export const convex = new ConvexReactClient(convexUrl);

/*
 * مزوّد المصادقة: يحفظ الجلسة ويرفق التوكن تلقائياً مع كل طلب،
 * فلا حاجة لتمرير أي شيء في نقاط الاستدعاء المئة.
 */
export const ConvexClientProvider = ({ children }) => {
  return <ConvexAuthProvider client={convex}>{children}</ConvexAuthProvider>;
};
